<div #screenDiv [ngClass]="{'app-share-screen': showScreen}"></div>

